export default __webpack_public_path__ + "mini-icon-ubuntu@2x.png";